"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPionex = exports.calcProfitPerGrid = exports.calcProfitPerGridOnGeometric = void 0;
const interfaces_1 = require("../interfaces");
const index_1 = require("../../index");
function getGridSingleProfit(lowParam, highParam, numberParam, feeRate) {
    if (!Number(highParam) ||
        !Number(lowParam) ||
        !Number(numberParam) ||
        Number(lowParam) >= Number(highParam) ||
        Number(numberParam) < 2) {
        return [0, 0];
    }
    const high = new index_1.SafeDecimal(highParam);
    const low = new index_1.SafeDecimal(lowParam);
    const count = new index_1.SafeDecimal(numberParam);
    const priceStep = high.sub(low).div(count.sub(1));
    let priceBelow = new index_1.SafeDecimal(0);
    let minProfit = new index_1.SafeDecimal(0);
    let maxProfit = new index_1.SafeDecimal(0);
    const fee = new index_1.SafeDecimal(feeRate);
    for (let i = 0; i < count.toNumber(); i++) {
        const price = low.add(priceStep.mul(i));
        if (priceBelow.greaterThan(0)) {
            if (maxProfit.lessThanOrEqualTo(0)) {
                // (price * (1 - feeRateDecimal) - priceBelow * (1 + feeRateDecimal)) / priceBelow;
                maxProfit = price
                    .mul(new index_1.SafeDecimal(1).sub(fee))
                    .sub(priceBelow.mul(new index_1.SafeDecimal(1).add(fee)))
                    .div(priceBelow);
            }
            // (price * (1 - feeRateDecimal) - priceBelow * (1 + feeRateDecimal)) / priceBelow;
            minProfit = price
                .mul(new index_1.SafeDecimal(1).sub(fee))
                .sub(priceBelow.mul(new index_1.SafeDecimal(1).add(fee)))
                .div(priceBelow);
        }
        priceBelow = price;
    }
    return [minProfit.toNumber(), maxProfit.toNumber()];
}
// 不处理精度, 仅仅用来计算
function calcProfitPerGridOnGeometric(top, bottom, count, fee) {
    if (!Number(top) || !Number(bottom) || !Number(count) || Number(count) < 2) {
        return 0;
    }
    const _fee = Number(fee) || 0;
    //Math.pow(top/bottom, 1/(gridCount - 1)) - (1 + 手续费率*2)
    const _top = new index_1.SafeDecimal(top);
    const _bottom = new index_1.SafeDecimal(bottom);
    const _count = new index_1.SafeDecimal(count);
    const _feeRate = new index_1.SafeDecimal(_fee);
    const result = index_1.SafeDecimal.pow(_top.div(_bottom), new index_1.SafeDecimal(1).div(_count.sub(1))).sub(_feeRate.mul(2).add(1));
    return result.toNumber();
}
exports.calcProfitPerGridOnGeometric = calcProfitPerGridOnGeometric;
// 处理精度, 用来展示
function calcProfitPerGrid(gridType, top, bottom, count, fee) {
    if (!Number(top) || !Number(bottom) || !Number(count)) {
        return undefined;
    }
    if (gridType === "arithmetic") {
        return getGridSingleProfit(bottom, top, count, fee).map((value, index, array) => {
            return new index_1.SafeDecimal(value).toDecimalPlaces(8, index_1.SafeDecimal.ROUND_FLOOR).toNumber();
        });
    }
    else {
        const result = calcProfitPerGridOnGeometric(top, bottom, count, fee);
        return [new index_1.SafeDecimal(result).toDecimalPlaces(8, index_1.SafeDecimal.ROUND_FLOOR).toNumber()];
    }
}
exports.calcProfitPerGrid = calcProfitPerGrid;
function isPionex(excludePionexLite) {
    const productType = (0, index_1.getTradeDependencyInstance)().getProductType();
    if (excludePionexLite) {
        return productType === interfaces_1.PRODUCT_TYPE.PIONEX || productType === interfaces_1.PRODUCT_TYPE.PIONEX_US;
    }
    return productType === interfaces_1.PRODUCT_TYPE.PIONEX || productType === interfaces_1.PRODUCT_TYPE.PIONEX_LITE || productType === interfaces_1.PRODUCT_TYPE.PIONEX_US;
}
exports.isPionex = isPionex;
